// FE-SCRM-053 — Sales Contact client-side types.
//
// Mirrors the BE-SCRM-005 serializer plus the FE-SCRM-053 additions:
// ``prospect_name`` on every flat-list row and ``opportunity_name``
// on every Role-by-contact row.

export interface SalesContact {
  contact_id: string;
  prospect_id: string;
  first_name: string;
  last_name: string;
  display_name: string;
  email: string | null;
  phone: string | null;
  title: string | null;
  is_primary: boolean;
  source: string | null;
  notes: string | null;
  prospect_name: string | null;
  created_at: string | null;
  updated_at: string | null;
}


export interface ContactListResponse {
  rows: SalesContact[];
  total: number;
  page: number;
  page_size: number;
}


export interface ContactListQuery {
  q?: string;
  prospect_id?: string[];
  is_primary?: boolean;
  include_archived?: boolean;
  page?: number;
  page_size?: number;
}


export interface ContactPatchInput {
  first_name?: string;
  last_name?: string;
  email?: string | null;
  phone?: string | null;
  title?: string | null;
  is_primary?: boolean;
  source?: string | null;
  notes?: string | null;
}


export type DecisionRole =
  | "economic_buyer" | "champion" | "coach"
  | "technical_evaluator" | "user" | "blocker" | "unknown";


export type InfluenceLevel = "high" | "medium" | "low";


export type Stance =
  | "supportive" | "neutral" | "skeptical" | "opposed" | "unknown";


export interface OpportunityContactRoleRow {
  role_id: string;
  opportunity_id: string;
  contact_id: string;
  opportunity_name: string;
  decision_role: DecisionRole;
  influence_level: InfluenceLevel;
  stance: Stance;
  last_touchpoint_at: string | null;
  notes: string | null;
  created_at: string | null;
  updated_at: string | null;
}


export interface ContactRolesResponse {
  rows: OpportunityContactRoleRow[];
  total: number;
}


// Display labels for the Roles table on Contact detail.
export const DECISION_ROLE_LABEL: Record<DecisionRole, string> = {
  economic_buyer: "Economic buyer",
  champion: "Champion",
  coach: "Coach",
  technical_evaluator: "Technical evaluator",
  user: "User",
  blocker: "Blocker",
  unknown: "Unknown",
};


export const INFLUENCE_LEVEL_LABEL: Record<InfluenceLevel, string> = {
  high: "High",
  medium: "Medium",
  low: "Low",
};


export const STANCE_LABEL: Record<Stance, string> = {
  supportive: "Supportive",
  neutral: "Neutral",
  skeptical: "Skeptical",
  opposed: "Opposed",
  unknown: "Unknown",
};
